import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportMemberRegularPage } from './report-member-regular.page';

const routes: Routes = [
  {
    path: '',
    component: ReportMemberRegularPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportMemberRegularPageRoutingModule {}
